import PageSpinner from '@src/components/PageSpinner'
import { useFeatureSwitchList } from '@src/data/api/credit-api/credit-api'
import { type JSX } from 'react'

interface Props {
  children: JSX.Element
}

// #62287 — gate auth flow on feature flags load: while fetching, render the loading
// spinner. Once fetch resolves (success or single-try failure with retry:false),
// unblock. On failure, downstream useFeatureFlags() returns {} → kill-switch active → standard login.
const FeatureFlagsGate = ({ children }: Props): JSX.Element => {
  const [featureSwitchInfo, isFetching] = useFeatureSwitchList()
  if (isFetching && !featureSwitchInfo) return <PageSpinner isLoading withBackdrop />
  return children
}

export default FeatureFlagsGate
